import { dialogClasses } from '@mui/material/Dialog'
import { dialogActionsClasses } from '@mui/material/DialogActions'
import { dialogContentClasses } from '@mui/material/DialogContent'
import { dialogTitleClasses } from '@mui/material/DialogTitle'
import { Scrollable } from '@/styles/scroll'

export const styles = {
  dialog: (width?: number, fullHeight?: boolean) => ({
    [`& .${dialogClasses.paper}`]: {
      width: width ? `${width}px` : '450px',
      maxWidth: 'none',
      height: fullHeight ? 'calc(100vh - 80px)' : 'max-content',
      borderRadius: '10px',
    },

    [`& .${dialogTitleClasses.root}`]: {
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '32px',
    },

    [`& .${dialogContentClasses.root}`]: {
      ...Scrollable,
      '& .MuiBox-root': {
        position: 'relative',
        backgroundColor: 'white',
        flexDirection: 'column',
      },
    },

    [`& .${dialogActionsClasses.root}`]: {
      padding: '24px 32px',

      '&>:not(:first-of-type)': {
        marginLeft: '16px',
      },
    },
  }),

  closeButton: {
    position: 'absolute',
    zIndex: '10',
    right: '25px',
    top: '22px',
    width: '30px',
    height: '30px',

    '&:hover': {
      filter: 'invert(1)',
      backgroundColor: 'white',
    },
  },
}
